// Precio en formato espanol a partir de centimos (asi llegan del backend).
//   900  -> "9 €"
//   480  -> "4,80 €"
//   1500 -> "15 €"
// El espacio antes del euro es no separable para que nunca quede "9" en una
// linea y "€" en la siguiente.
export const formatPrice = (cents) => {
  const euros = (Number(cents) || 0) / 100;
  const whole = Number.isInteger(euros);
  const number = whole
    ? String(euros)
    : euros.toFixed(2).replace('.', ',');
  return `${number} €`;
};

export default formatPrice;
